<h1>Race settings</h1>

<router-outlet></router-outlet>
